var mountNavigation = require("./MountNavigation").default;
require("Analytics/Analytics.ng.html");
module.exports = angular.module("qwilr.analytics", ["ui.router"]).config(function ($stateProvider) {
    $stateProvider.state("analytics", {
        url: "/analytics",
        templateUrl: "Analytics/Analytics.ng.html",
        data: {
            pageTitle: "Analytics",
        },
        controller: function ($scope, $rootScope) {
            var di = $rootScope.di.child();
            var accountAnalytics = di.make(require("./Account/Account"));
            var mainNav = di.invoke(mountNavigation);
            $scope.ui = {
                accountAnalytics: accountAnalytics.ui,
                mainNav: mainNav,
            };
        },
        onEnter: function ($rootScope) {
            $rootScope.accountAnalyticsStartViewTime = new Date().getTime();
        },
        onExit: function ($rootScope) {
            var endViewTime = new Date().getTime();
            var telemetry = $rootScope.di.get("telemetry");
            var viewTime = Math.floor((endViewTime - $rootScope.accountAnalyticsStartViewTime) / 1000);
            telemetry.trackOnly("Account Analytics Viewed", { account_analytics_view_time: viewTime });
        },
    });
});
